import { getWindowObject } from '@eventbrite/feature-detection';

export const getStatsigStableIDFromLocalStorage = () =>
    getWindowObject('localStorage')?.getItem('STATSIG_LOCAL_STORAGE_STABLE_ID');
